import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateTiersRequest = { tiers: '_tier' };
var _bulkCreateTiersResponse = { results: '_bulkTierResult' };
var _bulkTierResult = { item: '_tier' };
var _createTierRequest = { tier: '_tier' };
var _createTierResponse = { tier: '_tier' };
var _createTiersProgramSettingsRequest = {
    programSettings: '_tiersProgramSettings',
};
var _createTiersProgramSettingsResponse = {
    programSettings: '_tiersProgramSettings',
};
var _deleteTierRequest = {};
var _deleteTierResponse = {};
var _getTierRequest = {};
var _getTierResponse = { tier: '_tier' };
var _getTiersProgramRequest = {};
var _getTiersProgramResponse = {
    tiers: '_tier',
    programSettings: '_tiersProgramSettings',
};
var _getTiersProgramSettingsRequest = {};
var _getTiersProgramSettingsResponse = {
    programSettings: '_tiersProgramSettings',
};
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _listTiersRequest = {};
var _listTiersResponse = { tiers: '_tier' };
var _tier = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    tierDefinition: '_tierDefinition',
};
var _tierDefinition = { icon: '_image' };
var _tiersProgramSettings = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    baseTierDefinition: '_tierDefinition',
};
var _updateTierRequest = { tier: '_tier' };
var _updateTierResponse = { tier: '_tier' };
var _updateTiersProgramSettingsRequest = {
    programSettings: '_tiersProgramSettings',
};
var _updateTiersProgramSettingsResponse = {
    programSettings: '_tiersProgramSettings',
};
function resolveComWixpressLoyaltyTierLoyaltyTiersUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/loyalty-tiers',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/loyalty-tiers',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/loyalty-tiers',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/loyalty-tiers',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/loyalty-tiers',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/loyalty-tiers',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/loyalty-tiers',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/loyalty-tiers',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/loyalty-tiers',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/loyalty-tiers',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/loyalty-tiers',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a tier.
 *
 * The name for a tier and the amount of required points to qualify for a tier can only exist for a single tier.
 * Attempts to create a tier with a `tierDefinition.name` or `requiredPoints` that already exists will return an error.
 *
 * To create up to 20 tiers at once, use [Bulk Create Tiers](https://dev.wix.com/api/rest/wix-loyalty-program/tiers/bulk-create-tiers).
 *
 * >**Note:** You must have a [Business VIP Premium plan](https://support.wix.com/en/article/business-vip-premium-plan-overview)
 * >or a [Scale Premium plan](https://support.wix.com/en/article/editor-x-scale-premium-plan-overview) to add tiers.
 */
export function createTier(payload) {
    var _a = serializer(_createTierRequest, {
        _image: _image,
        _tier: _tier,
        _tierDefinition: _tierDefinition,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createTierResponse, {
        _image: _image,
        _tier: _tier,
        _tierDefinition: _tierDefinition,
    }).fromJSON;
    function __createTier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.tier',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.tier.LoyaltyTiers.CreateTier',
            url: resolveComWixpressLoyaltyTierLoyaltyTiersUrl({
                protoPath: '/v1/tiers',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createTier.fromReq = fromReq;
    __createTier.__isAmbassador = true;
    return __createTier;
}
/**
 * Creates up to 20 tiers.
 *
 * The name for a tier and the amount of required points to qualify for a tier can only exist for a single tier.
 * Attempts to create a tier with a `tierDefinition.name` or `requiredPoints` that already exists will return an error.
 *
 * To create a single tier, use [Create Tier](https://dev.wix.com/api/rest/wix-loyalty-program/tiers/create-tier).
 *
 * >**Note:** You must have a [Business VIP Premium plan](https://support.wix.com/en/article/business-vip-premium-plan-overview)
 * >or a [Scale Premium plan](https://support.wix.com/en/article/editor-x-scale-premium-plan-overview) to add tiers.
 */
export function bulkCreateTiers(payload) {
    var _a = serializer(_bulkCreateTiersRequest, { _image: _image, _tier: _tier, _tierDefinition: _tierDefinition }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateTiersResponse, {
        _bulkTierResult: _bulkTierResult,
        _image: _image,
        _tier: _tier,
        _tierDefinition: _tierDefinition,
    }).fromJSON;
    function __bulkCreateTiers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.tier',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.tier.LoyaltyTiers.BulkCreateTiers',
            url: resolveComWixpressLoyaltyTierLoyaltyTiersUrl({
                protoPath: '/v1/bulk/tiers/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateTiers.fromReq = fromReq;
    __bulkCreateTiers.__isAmbassador = true;
    return __bulkCreateTiers;
}
/**
 * Retrieves a loyalty tier.
 *
 * To retrieve a list of all of a site's tiers, use [List Tiers](https://dev.wix.com/docs/rest/crm/loyalty-program/tiers/list-tiers).
 */
export function getTier(payload) {
    var _a = serializer(_getTierRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTierResponse, {
        _image: _image,
        _tier: _tier,
        _tierDefinition: _tierDefinition,
    }).fromJSON;
    function __getTier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.tier',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.tier.LoyaltyTiers.GetTier',
            url: resolveComWixpressLoyaltyTierLoyaltyTiersUrl({
                protoPath: '/v1/tiers/{tierId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTier.fromReq = fromReq;
    __getTier.__isAmbassador = true;
    return __getTier;
}
/**
 * Updates a loyalty tier.
 *
 * Use this endpoint to update tier-specific settings, such as the name and the required points
 * threshold of an individual loyalty tier. To update global settings that apply to all of a site's loyalty tiers,
 * use [Update Tiers Program Settings](https://dev.wix.com/docs/rest/crm/loyalty-program/tiers/update-tiers-program-settings).
 */
export function updateTier(payload) {
    var _a = serializer(_updateTierRequest, {
        _image: _image,
        _tier: _tier,
        _tierDefinition: _tierDefinition,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTierResponse, {
        _image: _image,
        _tier: _tier,
        _tierDefinition: _tierDefinition,
    }).fromJSON;
    function __updateTier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.tier',
            method: 'PATCH',
            methodFqn: 'com.wixpress.loyalty.tier.LoyaltyTiers.UpdateTier',
            url: resolveComWixpressLoyaltyTierLoyaltyTiersUrl({
                protoPath: '/v1/tiers/{tier.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTier.fromReq = fromReq;
    __updateTier.__isAmbassador = true;
    return __updateTier;
}
/** Deletes a loyalty tier. */
export function deleteTier(payload) {
    var _a = serializer(_deleteTierRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteTierResponse, {}).fromJSON;
    function __deleteTier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.tier',
            method: 'DELETE',
            methodFqn: 'com.wixpress.loyalty.tier.LoyaltyTiers.DeleteTier',
            url: resolveComWixpressLoyaltyTierLoyaltyTiersUrl({
                protoPath: '/v1/tiers/{tierId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteTier.fromReq = fromReq;
    __deleteTier.__isAmbassador = true;
    return __deleteTier;
}
/**
 * Retrieves a list of a site's tiers.
 *
 * To retrieve a specific tier, use [Get Tier](https://dev.wix.com/docs/rest/crm/loyalty-program/tiers/get-tier).
 */
export function listTiers(payload) {
    var _a = serializer(_listTiersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTiersResponse, {
        _image: _image,
        _tier: _tier,
        _tierDefinition: _tierDefinition,
    }).fromJSON;
    function __listTiers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.tier',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.tier.LoyaltyTiers.ListTiers',
            url: resolveComWixpressLoyaltyTierLoyaltyTiersUrl({
                protoPath: '/v1/tiers',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listTiers.fromReq = fromReq;
    __listTiers.__isAmbassador = true;
    return __listTiers;
}
/**
 * Create tiers program settings.
 *
 * Tiers program settings apply globally to all tiers in the program.
 */
export function createTiersProgramSettings(payload) {
    var _a = serializer(_createTiersProgramSettingsRequest, { _image: _image, _tierDefinition: _tierDefinition, _tiersProgramSettings: _tiersProgramSettings }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createTiersProgramSettingsResponse, { _image: _image, _tierDefinition: _tierDefinition, _tiersProgramSettings: _tiersProgramSettings }).fromJSON;
    function __createTiersProgramSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.tier',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.tier.LoyaltyTiers.CreateTiersProgramSettings',
            url: resolveComWixpressLoyaltyTierLoyaltyTiersUrl({
                protoPath: '/v1/tiers/program-settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createTiersProgramSettings.fromReq = fromReq;
    __createTiersProgramSettings.__isAmbassador = true;
    return __createTiersProgramSettings;
}
/**
 * Returns `Tiers` and `ProgramSettings` in a single response.
 *
 * If `TiersProgramSettings` doesn't exist, default `TiersProgramSettings` are created.
 */
export function getTiersProgram(payload) {
    var _a = serializer(_getTiersProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTiersProgramResponse, {
        _image: _image,
        _tier: _tier,
        _tierDefinition: _tierDefinition,
        _tiersProgramSettings: _tiersProgramSettings,
    }).fromJSON;
    function __getTiersProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.tier',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.tier.LoyaltyTiers.GetTiersProgram',
            url: resolveComWixpressLoyaltyTierLoyaltyTiersUrl({
                protoPath: '/v1/tiers/program',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTiersProgram.fromReq = fromReq;
    __getTiersProgram.__isAmbassador = true;
    return __getTiersProgram;
}
/**
 * Retrieves the settings for the tiers program.
 *
 * Tiers program settings apply globally to all tiers in the program.
 */
export function getTiersProgramSettings(payload) {
    var _a = serializer(_getTiersProgramSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTiersProgramSettingsResponse, {
        _image: _image,
        _tierDefinition: _tierDefinition,
        _tiersProgramSettings: _tiersProgramSettings,
    }).fromJSON;
    function __getTiersProgramSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.tier',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.tier.LoyaltyTiers.GetTiersProgramSettings',
            url: resolveComWixpressLoyaltyTierLoyaltyTiersUrl({
                protoPath: '/v1/tiers/program-settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTiersProgramSettings.fromReq = fromReq;
    __getTiersProgramSettings.__isAmbassador = true;
    return __getTiersProgramSettings;
}
/**
 * Updates the global settings of a loyalty tier program.
 *
 * Use this endpoint to update settings that apply to all of a site's loyalty tiers.
 * To update tier-specific settings for an individual tier, use
 * [Update Tier](https://dev.wix.com/docs/rest/crm/loyalty-program/tiers/update-tier).
 *
 * By default, the `status` of a tiers program is set to `DISABLED` and must be manually updated to `ACTIVE` using
 * this endpoint or through a site owner's [dashboard](https://manage.wix.com/account/site-selector/?actionUrl=https%3A%2F%2Fwww.wix.com%2Fdashboard%2F%7BmetaSiteId%7D%2Floyalty-accounts%2Fmanage%3Ftab%3Dpoints-and-rewards&title=Select+a+Site&primaryButtonText=Select+Site).
 *
 * >**Note:** The `status`, `revision`, and `rollingWindow` parameters must be passed to update the tiers program settings.
 * >The `baseTierDefinition` fields are not required, however, if you don't pass them they will reset to
 * >their default values of empty fields.
 */
export function updateTiersProgramSettings(payload) {
    var _a = serializer(_updateTiersProgramSettingsRequest, { _image: _image, _tierDefinition: _tierDefinition, _tiersProgramSettings: _tiersProgramSettings }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTiersProgramSettingsResponse, { _image: _image, _tierDefinition: _tierDefinition, _tiersProgramSettings: _tiersProgramSettings }).fromJSON;
    function __updateTiersProgramSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.tier',
            method: 'PATCH',
            methodFqn: 'com.wixpress.loyalty.tier.LoyaltyTiers.UpdateTiersProgramSettings',
            url: resolveComWixpressLoyaltyTierLoyaltyTiersUrl({
                protoPath: '/v1/tiers/program-settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTiersProgramSettings.fromReq = fromReq;
    __updateTiersProgramSettings.__isAmbassador = true;
    return __updateTiersProgramSettings;
}
//# sourceMappingURL=http.impl.js.map